(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    var run = function () {
      document.querySelectorAll('[data-pd-swap]:not([data-pd-ready])').forEach(function (box) {
        box.setAttribute('data-pd-ready', '');
        var sw = box.querySelector('[data-swap]');
        if (!sw) return;
        sw.setAttribute('data-swap-seen', '');
        var t;
        var play = function () { clearTimeout(t); sw.classList.add('is-on'); t = setTimeout(function () { sw.classList.remove('is-on'); }, 2600); };
        setTimeout(play, 700);
        box.addEventListener('click', function () { if (sw.classList.contains('is-on')) { clearTimeout(t); sw.classList.remove('is-on'); } else play(); });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  })();

  } catch(e) { console.error(e); }
})();
})();
